﻿export class EnviarToken {
 
    emailUsuario: string;
     
}